<template>
  <div>
      <div class="cont-list">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="top">
            <img src="@images/home.png" class="icon-house" style="width: 18px; height: 15px" />
            <span class="houseNumber">{{ item.houseNumber }}</span>
          </div>
          <div style="padding: 10px">
            <div v-if="item.personName" class="card-item">
              <span class="xm">{{ item.personName }}</span>
              <span class="idNumber">{{ onPassCard(item.personNumber) }}</span>
            </div>
            <div v-else class="card-item">
              <span class="idNumber">未添加户主信息</span>
            </div>
            <div class="card-item">
              <img src="@images/jtrs.png" class="icon" style="width: 15px; height: 14px" />
              <span class="value">{{ item.personListNumber || '--' }}人</span>
            </div>
            <div class="card-item">
              <img src="@images/map.png" class="icon" style="width: 13px; height: 15px" />
              <span class="value">{{ item.address || '--' }}</span>
            </div>
          </div>
          <div class="card-btn">
            <div class="card-btn-item" @click="clickView(item)">
              <img src="@images/eye.png" class="img" style="width: 16px; height: 14px" />
              <span></span>
              查看详情
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    ifAdd: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },

  methods: {
    clickView(item) {
      let params = { houseNumber: item.houseNumber, ifEdit: this.ifAdd }
       this.$router.push({
                path: '/dqfw/sbd-view',
                query:params,
          })
    },
    onPassCard(str) {
      if (null != str && str != undefined) {
        if (str.length == 18) {
          var pat = /(\d{10})\d*(\d{2})/
          return str.replace(pat, '$1******$2')
        } else {
          var pat = /\d*(\d{2})/
          let string = ''
          for (let i = 0; i < str.length; i++) {
            if (i == str.length - 2 || i == str.length - 1) {
              string += str[i]
            } else {
              string += '*'
            }
          }

          return string
        }
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  padding: 12px;
}

.cont-list {
  padding: 15px 10px;
}
.list-item {
  background: #fff;
  border-radius: 5px;
  padding-bottom: 0;
  margin-bottom: 10px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);

  .top {
    height: 35px;
    border-bottom: 1px solid #e2e2e2;
    padding: 0 12px;
    display: flex;
    align-items: center;
    font-size: 14px;

    .icon-house {
      width: 19px;
      height: 19px;
      margin-right: 10px;
    }
    .houseNumber {
      color: #696969;
    }
  }

  .card-item {
    display: flex;
    font-size: 14px;
    align-items: center;
    margin-bottom: 10px;
    .xm {
      color: #333;
      font-size: 15px;
      font-weight: 500;
      margin-right: 6px;
    }
    .idNumber {
      color: #696969;
    }
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .value {
    }
  }
}

.card-btn {
  display: flex;
  align-items: center;
  text-align: center;
  border-top: 1px solid #e2e2e2;
  // margin-top: 20rpx;

  div {
    flex: 1;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }

    &:active {
      background-color: #eeeeee;
    }

    &:not(:last-child) {
      border-right: 1px solid #e2e2e2;
    }
  }
}
</style>
